import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "emh-stage-campaign-item__hide-notification" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.t('dcp.sfp.stageCampaign.hideNotification', {
        defaultValue: `This campaign item won't be shown on a published page. It can be adjusted in the component dialog: "General -> Hide item".`,
      })), 1))
}